//----- Component --------------------------------------------------------/
// Developer     : Guillermo Sedran
// Creation Date : 13/11/2023
// Version       : 1
// Description   : Menú con las acciones de un hallazgo y sus estados
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   :
// Change by     :
// Change description:
//
// Change Date   :
// Change by     :
// Change description:
//
//========================================================================/
import React, { useEffect, useState } from "react";
import { UrlApi } from "../../services/apirest";
import {
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Box,
  Stack,
  Grid,
  Tooltip,
  TextField,
  Typography,
} from "@mui/material";

// LOG EVENTOS
import { logEventos } from "../../services/services";

// ENVIAR MAILS
import { enviarmails } from "../../services/services";

// ICONOS
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelIcon from "@mui/icons-material/Cancel";
import PlayCircleFilledWhiteIcon from "@mui/icons-material/PlayCircleFilledWhite";

// Notification
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

import Auditorias_agregar_accion from "./Auditorias_agregar_accion";

//ADJUNTAR ARCHIVOS
import { v4 as uuidv4 } from "uuid";
import FileUploadAccion from "./FileUploadAccion";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function Auditorias_acciones(props) {
  const [auditoriasAcciones, setAuditoriasAcciones] = useState([]);
  const [auditoriasAccionesFecha, setAuditoriasAccionesFecha] = useState([]);
  // Obtengo el estado (Iniciado, finalizado)
  const [auditoriasAccionesEstado, setAuditoriasAccionesEstado] = useState([]);
  // Obtengo el ID del estado
  const [auditoriasAccionesEstado2, setAuditoriasAccionesEstado2] = useState(
    []
  );
  const [auditoriasAccionesID, setAuditoriasAccionesID] = useState([]);

  const [auditoriasAccionesUUID, setAuditoriasAccionesUUID] = useState([]);
  const [
    auditoriasAccionesUsuarioQueRegistro,
    setAuditoriasAccionesUsuarioQueRegistro,
  ] = useState([]);
  const [
    auditoriasAccionesUsuarioQueFinalizo,
    setAuditoriasAccionesUsuarioQueFinalizo,
  ] = useState([]);

  const [accionSeleccionada, setAccionSeleccionada] = useState("");
  const [idSeleccionado, setIdSeleccionado] = useState(""); // Estado para almacenar el ID seleccionado

  const [row, setRow] = useState(props.row);

  // PARA ACTIVAR/DESACTIVAR BOTÓN DE GUARDAR CAMBIOS AL EDITAR
  const [valorInicial, setValorInicial] = useState("");
  const [hayCambios, setHayCambios] = useState(false);
  const [valoresListos, setValoresListos] = useState(false);

  //*************************************************************************************************************************************/

  // ADJUNTOS
  const [uuid_accion, setUuid_accion] = useState(uuidv4()); //ADJUNTAR ARCHIVOS
  const [openCloseAdj, setOpenCloseAdj] = useState(false); //ADJUNTAR COMPROBANTE
  const [newUuid, setNewUuid] = useState(""); //ADJUNTAR COMPROBANTE

  const handleOpenCloseAdj = (value) => {
    setOpenCloseAdj(value);
  };

  //*************************************************************************************************************************************/

  // Función para volver a obtener las auditorías
  const actualizarAuditorias = () => {
    console.log("SE EJECUTA ActualizarAuditorias");
    props.obtenerAuditorias(); // Llama a la función que realiza el fetch
  };

  // OBTENER FECHA ACTUAL
  var curr = new Date();
  curr.setDate(curr.getDate());
  var date = curr.toISOString().substring(0, 10);

  //*************************************************************************************************************************************/

  //Notification
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");

  //*************************************************************************************************************************************/

  //Snackbar Notificacion
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
    setOpenEditar(false);
    setOpenDialogEliminar(false);
    setOpenDialogFinalizar(false);
    obtenerAuditoriasAcciones();
  };

  // ---------------------------------------------------------------

  const obtenerAuditoriasAcciones = () => {
    fetch(UrlApi + "/auditorias_acciones/hallazgo/" + row.original.id_hallazgo)
      .then((data) => data.json())
      .then((data) => {

        const acciones = [...data];

        const accionesRealizadas = acciones.map(
          (accion) => accion.accion_realizada
        );
        const accionesRealizadasFecha = acciones.map((fecha) => fecha.fecha);
        const accionesRealizadasEstado = acciones.map((estado) => estado.valor);
        const accionesRealizadasEstado2 = acciones.map(
          (estado) => estado.estado
        );
        const accionesRealizadasID = acciones.map(
          (id_accion) => id_accion.id_accion
        );
        const accionesRealizadasUUID = acciones.map(
          (uuid_accion) => uuid_accion.uuid_accion
        );
        const auditoriasAccionesUsuarioQueRegistro = acciones.map(
          (usuario_que_registra) => usuario_que_registra.usuario_que_registra
        );
        const auditoriasAccionesUsuarioQueFinalizo = acciones.map(
          (usuario_que_finaliza) => usuario_que_finaliza.usuario_que_finaliza
        );

        setAuditoriasAcciones(accionesRealizadas);
        setAuditoriasAccionesFecha(accionesRealizadasFecha);
        setAuditoriasAccionesEstado(accionesRealizadasEstado);
        setAuditoriasAccionesEstado2(accionesRealizadasEstado2);
        setAuditoriasAccionesID(accionesRealizadasID);
        setAuditoriasAccionesUUID(accionesRealizadasUUID);
        setAuditoriasAccionesUsuarioQueRegistro(
          auditoriasAccionesUsuarioQueRegistro
        );
        setAuditoriasAccionesUsuarioQueFinalizo(
          auditoriasAccionesUsuarioQueFinalizo
        );
      });
  };

  // ---------------------------------------------------------------

  useEffect(() => {
    obtenerAuditoriasAcciones();
  }, []);

  // ---------------------------------------------------------------
  //  DIALOG PARA CARGA DE ACCION
  const [openDialogAgregarAccion, setOpenDialogAgregarAccion] =
    React.useState(false);

  const handleCloseDialogCrearAccion = () => {
    setOpenDialogAgregarAccion(!openDialogAgregarAccion);
    // RECARGAR TABLA
    obtenerAuditoriasAcciones();
  };

  const handleOpenDialogCrearAccion = () => {
    setOpenDialogAgregarAccion(true);
    // GENERAR UUID PARA ARCHIVOS ADJUNTOS
    setUuid_accion(uuidv4());
    setNewUuid(uuid_accion);
  };

  //*************************************************************************************************************************************/

  // DIALOG PARA EDITAR LOS DATOS
  const [openEditar, setOpenEditar] = React.useState(false);

  // TOMO LOS DATOS DE ESA FILA
  const handleClickOpenEditar = (accion, id) => {
    setOpenEditar(true);
    setValorInicial(accion);
    setAccionSeleccionada(accion);
    setIdSeleccionado(id);
    setValoresListos(true);
  };

  const handleCloseEditar = () => {
    setOpenEditar(false);
    setAccionSeleccionada("");
    setValorInicial("");
    setValoresListos(false);
  };

  //**********************************************************************************************/

  // DIALOG PARA ELIMINAR LA ACCIÓN
  const [openDialogEliminar, setOpenDialogEliminar] = React.useState(false);

  const dialogEliminar = (id, accion) => {
    setOpenDialogEliminar(true);
    setAccionSeleccionada(accion);
    setIdSeleccionado(id);
  };

  const handleCloseDialogEliminar = () => {
    setOpenDialogEliminar(!openDialogEliminar);
  };

  //**********************************************************************************************/

  // DIALOG PARA FINALIZAR LA ACCIÓN
  const [openDialogFinalizar, setOpenDialogFinalizar] = React.useState(false);

  const dialogFinalizar = (id) => {
    setOpenDialogFinalizar(true);
    setIdSeleccionado(id);
  };

  const handleCloseDialogFinalizar = () => {
    setOpenDialogFinalizar(!openDialogFinalizar);
  };

  //**********************************************************************************************/

  const guardarEditar = async (e) => {
    logEventos(
      "Guardar editar accion",
      "Auditorias",
      "Se guardo la edicion de una accion",
      localStorage.getItem("user")
    );
    e.preventDefault();
    await fetch(
      UrlApi + "/auditorias_acciones/" + idSeleccionado, // Usar idSeleccionado en lugar de datosAuditoriaAcciones.id_accion
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          accion_realizada: accionSeleccionada,
        }),
      }
    )
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("La acción se guardó exitosamente !");
          console.log("Guardado");
          enviarmails(
            row.original.email_auditor,
            "Auditoria: Acción Editada",
            `
            <div style="background-color: #f2f2f2; border-radius: 10px; padding: 20px; text-align: center;">
            <p>Se editó una acción del hallazgo "${row.original.problema_sugerencia}" de la sucursal: ${row.original.sucursal} .</p>
            <p><b>Descripción de la acción:</b> "${accionSeleccionada}" .</p>
            </div>`
          );
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al guardar la acción");
          console.log("Error");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  //*************************************************************************************************************************************/

  const guardarFinalizar = async (e) => {
    logEventos(
      "Finalizar accion",
      "Auditorias",
      "Finalizar accion de hallazgo",
      localStorage.getItem("user")
    );

    e.preventDefault();
    await fetch(UrlApi + "/auditorias_acciones/" + idSeleccionado, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        // 183 = FINALIZADO
        estado: 183,
        usuario_que_finaliza: localStorage.getItem("user"),
      }),
    })
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("La acción se guardó exitosamente !");
          console.log("Guardado");
          props.closeSnackPrincipal();
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al guardar la acción");
          console.log("Error");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });

    await fetch(
      UrlApi +
        "/auditorias_acciones/hallazgo/sincancelado/" +
        row.original.id_hallazgo
    )
      .then((data) => data.json())
      .then(async (data) => {
        const todasAccionesFinalizadas = data.every(
          // 183 = FINALIZADO
          (accion) => accion.estado === 183
        );

        if (todasAccionesFinalizadas) {
          fetch(UrlApi + "/auditorias/" + row.original.id_hallazgo, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              estado: 180,
            }),
          });

          enviarmails(
            row.original.email_auditor,
            "Auditoria: Hallazgo Finalizado",
            `
            <div style="background-color: #f2f2f2; border-radius: 10px; padding: 20px; text-align: center;">

            <p>Se finalizó el hallazgo "${row.original.problema_sugerencia}" de la sucursal: ${row.original.sucursal} .</p>
            </div>`
          );
        } else {
          fetch(UrlApi + "/auditorias/" + row.original.id_hallazgo, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              estado: 179,
            }),
          });
        }
      })

      .catch((err) => {
        console.log(err.message);
      });
    // Después de actualizar el estado de la auditoría, Llamo a la función que actualiza las auditorías
    actualizarAuditorias();
  };

  //*************************************************************************************************************************************/

  const guardarEliminar = async (e) => {
    logEventos(
      "Eliminar accion",
      "Auditorias",
      "Eliminar accion de hallazgo",
      localStorage.getItem("user")
    );

    e.preventDefault();
    await fetch(
      UrlApi + "/auditorias_acciones/" + idSeleccionado, // Usar idSeleccionado en lugar de datosAuditoriaAcciones.id_accion
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          estado: 185,
          usuario_que_finaliza: localStorage.getItem("user"),
        }),
      }
    ).then((res) => {
      if (!res.err) {
        setOpenSnack(true);
        setColorMensaje("#D4EFDF");
        setMensaje("La acción se guardó exitosamente !");
      } else {
        setOpenSnack(false);
        setColorMensaje("#F1948A");
        setMensaje("Error al guardar la acción");
      }
    });

    await fetch(
      UrlApi +
        "/auditorias_acciones/hallazgo/sincancelado/" +
        row.original.id_hallazgo
    )
      .then((data) => data.json())
      .then(async (data) => {
        const todasAccionesFinalizadas = data.every(
          // 183 = FINALIZADO
          (accion) => accion.estado === 183
        );

        if (todasAccionesFinalizadas) {
          fetch(UrlApi + "/auditorias/" + row.original.id_hallazgo, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              // 180 = FINALIZADO
              estado: 180,
            }),
          });
        } else {
          fetch(UrlApi + "/auditorias/" + row.original.id_hallazgo, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              // 179 = EN PROCESO
              estado: 179,
            }),
          });
        }
      })

      .catch((err) => {
        console.log(err.message);
      });
    // Después de actualizar el estado de la auditoría, Llamo a la función que actualiza las auditorías
    await actualizarAuditorias();
  };

  //*************************************************************************************************************************************/

  const formatFecha = (fecha) => {
    const date = new Date(fecha);
    const dia = date.getDate() + 1; // Sumamos 1 porque los dias empiezan con 0
    const mes = date.getMonth() + 1; // Sumamos 1 porque los meses empiezan con 0
    const año = date.getFullYear();

    // Formateo para obtener "DD/MM/AAAA"
    const fechaFormateada = `${dia}/${mes}/${año}`;
    return fechaFormateada;
  };

  //*************************************************************************************************************************************/

  // Comparar el valor inicial con el valor actual del Textfield
  React.useEffect(() => {
    if (accionSeleccionada !== "" && valorInicial !== "" && valoresListos) {
      if (accionSeleccionada !== valorInicial) {
        setHayCambios(true);
      } else {
        setHayCambios(false);
      }
    }
  }, [accionSeleccionada, valorInicial, valoresListos]);

  return (
    <>
      <Box
        sx={{
          py: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          width: "100%",
        }}
      >
        <Box
          sx={{
            maxWidth: "900px",
            width: "100%",
            px: 2,
          }}
        >
          <Grid container mb={1}>
            {
              // ESTÁ APROBADO?
              row.original.estado === 181 ? (
                // ES AUDITOR?
                localStorage.getItem("auditor") === 1 ? (
                  // SI ES ADMIN Y ESTÄ EL HALLAZGO APROBADO
                  <>
                    <Grid item xs={12}>
                      <Button
                        variant="contained"
                        color="primary"
                        startIcon={<AddBoxTwoToneIcon />}
                        onClick={handleOpenDialogCrearAccion}
                        size="small"
                        fullWidth
                        sx={{
                          background:
                            "linear-gradient(135deg, #2471A3 0%, #0b476eff 100%)",
                          borderRadius: "12px",
                          textTransform: "none",
                          fontWeight: 600,
                          py: 1.5,
                          "&:hover": {
                            background:
                              "linear-gradient(135deg, #14527cff 0%, #022d49ff 100%)",
                          },
                        }}
                      >
                        Agregar Acción
                      </Button>
                    </Grid>
                  </>
                ) : // SI EL HALLAZGO ESTÁ APROBADO Y NO ES AUDITOR
                null
              ) : (
                // --- SI EL HALLAZGO NO ESTÁ APROBADO ---
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                >
                  {Number.parseInt(localStorage.getItem("sector")) ===
                    Number.parseInt(row.original.id_sector_delegado) &&
                  row.original.estado_delegacion === 1 ? (
                    // Delegación aceptada: el Box tiene un ancho controlado, el Button usa fullWidth para llenarlo
                    <Box
                      sx={{
                        width: { xs: "100%", sm: 320 },
                      }}
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        startIcon={<AddBoxTwoToneIcon />}
                        onClick={handleOpenDialogCrearAccion}
                        size="small"
                        disableElevation
                        fullWidth
                        sx={{
                          background:
                            "linear-gradient(135deg, #2471A3 0%, #0b476eff 100%)",
                          borderRadius: "12px",
                          textTransform: "none",
                          fontWeight: 600,
                          py: 1.5,
                          "&:hover": {
                            background:
                              "linear-gradient(135deg, #14527cff 0%, #022d49ff 100%)",
                          },
                        }}
                      >
                        Agregar Acción
                      </Button>
                    </Box>
                  ) : Number.parseInt(localStorage.getItem("sector")) ===
                      Number.parseInt(row.original.id_sector_delegado) &&
                    row.original.estado_delegacion !== 1 ? (
                    // Mensaje amarillo
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        p: 2,
                        backgroundColor: "#fff3cd",
                        border: "1px solid #ffeaa7",
                        borderRadius: "12px",
                        color: "#856404",
                      }}
                    >
                      <ErrorIcon sx={{ color: "#f39c12", mr: 1 }} />
                      <Typography variant="body2" fontWeight={600}>
                        Debe aceptar la delegación para agregar una acción
                      </Typography>
                    </Box>
                  ) : (
                    // Caso por defecto
                    <Box
                      sx={{
                        width: "100%",
                      }}
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        startIcon={<AddBoxTwoToneIcon />}
                        onClick={handleOpenDialogCrearAccion}
                        size="small"
                        disableElevation
                        fullWidth
                        sx={{
                          background:
                            "linear-gradient(135deg, #2471A3 0%, #0b476eff 100%)",
                          borderRadius: "12px",
                          textTransform: "none",
                          fontWeight: 600,
                          py: 2.2,
                          "&:hover": {
                            background:
                              "linear-gradient(135deg, #14527cff 0%, #022d49ff 100%)",
                          },
                        }}
                      >
                        Agregar Acción
                      </Button>
                    </Box>
                  )}
                </Grid>
              )
            }
          </Grid>

          <Box sx={{ position: "relative", pl: 4 }}>
            {auditoriasAcciones.length > 0 && (
              // LINEA DE TIEMPO
              <Box
                sx={{
                  position: "absolute",
                  left: "24px",
                  top: "28px",
                  bottom: "28px",
                  width: "3px",
                  background:
                    "linear-gradient(180deg, #2471A3 0%, #0b476eff 100%)",
                  borderRadius: "2px",
                  zIndex: 1,
                }}
              />
            )}

            {auditoriasAcciones.map((accion, index) => {
              const statusColor =
                auditoriasAccionesEstado2[index] === 185
                  ? "#ef4444"
                  : // Cancelado - rojo
                  auditoriasAccionesEstado2[index] === 183
                  ? "#22c55e"
                  : // Finalizado - verde
                    "#f59e0b"; // Iniciado - ambar

              const statusBgColor =
                auditoriasAccionesEstado2[index] === 185
                  ? "#fef2f2"
                  : // Cancelado - rojo
                  auditoriasAccionesEstado2[index] === 183
                  ? "#f0fdf4"
                  : // Finalizado - verde
                    "#fffbeb"; // Iniciado - ambar

              return (
                <Box
                  key={auditoriasAccionesID?.[index] ?? index}
                  sx={{
                    position: "relative",
                    display: "flex",
                    alignItems: "flex-start",
                    mb: 4,
                    pl: 2,
                  }}
                >
                  <Box
                    sx={{
                      position: "absolute",
                      left: "-40px",
                      top: "20px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      zIndex: 2,
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: "white",
                        border: "3px solid #2471A3",
                        borderRadius: "50%",
                        width: "16px",
                        height: "16px",
                        mb: 1,
                      }}
                    />
                    <Box
                      sx={{
                        backgroundColor: "#f8fafc",
                        border: "1px solid #e2e8f0",
                        borderRadius: "8px",
                        py: 0.5,
                        minWidth: "65px",
                        textAlign: "center",
                        userSelect: "none",
                        cursor: "default",
                      }}
                    >
                      <Typography
                        variant="caption"
                        sx={{
                          fontWeight: 600,
                          color: "#475569",
                          fontSize: "0.8rem",
                          lineHeight: 1.2,
                        }}
                      >
                        {formatFecha(auditoriasAccionesFecha[index])}
                      </Typography>
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      flex: 1,
                      ml: 3,
                      minWidth: "500px",
                      maxWidth: "700px",
                      borderRadius: "16px",
                      overflow: "hidden",
                      boxShadow:
                        "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                      border: "1px solid #e5e7eb",
                      transition: "all 0.2s ease-in-out",
                      "&:hover": {
                        boxShadow:
                          "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
                        transform: "translateY(-1px)",
                      },
                    }}
                  >
                    {/* Header */}
                    <Box
                      sx={{
                        background:
                          "linear-gradient(135deg, #2471A3 0%, #0b476eff 100%)",
                        color: "white",
                        p: 2,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 2 }}
                      >
                        <Box
                          sx={{
                            backgroundColor: statusBgColor,
                            color: statusColor,
                            borderRadius: "20px",
                            px: 2,
                            py: 0.5,
                            fontSize: "0.75rem",
                            fontWeight: 600,
                            textTransform: "uppercase",
                            letterSpacing: "0.05em",
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            lineHeight: 1,
                            userSelect: "none",
                            cursor: "default",
                          }}
                        >
                          {auditoriasAccionesEstado2[index] === 182 && (
                            <PlayCircleFilledWhiteIcon fontSize="small" />
                          )}
                          {auditoriasAccionesEstado2[index] === 183 && (
                            <CheckCircleOutlineIcon fontSize="small" />
                          )}
                          {auditoriasAccionesEstado2[index] === 185 && (
                            <CancelIcon fontSize="small" />
                          )}
                          {auditoriasAccionesEstado[index]}
                        </Box>
                      </Box>

                      {/* Acciones */}
                      <Box sx={{ display: "flex", gap: 0.5 }}>
                        {auditoriasAccionesEstado2[index] === 182 && (
                          <Tooltip arrow placement="bottom" title="Editar">
                            <IconButton
                              size="small"
                              onClick={() =>
                                handleClickOpenEditar(
                                  accion,
                                  auditoriasAccionesID[index]
                                )
                              }
                              sx={{
                                color: "white",
                                backgroundColor: "rgba(255, 255, 255, 0.1)",
                                "&:hover": {
                                  backgroundColor: "rgba(255, 255, 255, 0.2)",
                                },
                              }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        )}

                        {(Number.parseInt(localStorage.getItem("auditor")) ===
                          1 ||
                          Number.parseInt(
                            localStorage.getItem("controlador")
                          ) === 1) &&
                          auditoriasAccionesEstado2[index] === 182 && (
                            <Tooltip
                              arrow
                              placement="bottom"
                              title="Cancelar Acción"
                            >
                              <IconButton
                                size="small"
                                onClick={() =>
                                  dialogEliminar(auditoriasAccionesID[index])
                                }
                                sx={{
                                  color: "white",
                                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                                  "&:hover": {
                                    backgroundColor: "rgba(255, 255, 255, 0.2)",
                                  },
                                }}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          )}

                        {auditoriasAccionesUUID[index] !== null && (
                          <Tooltip arrow placement="bottom" title="Adjuntos">
                            <IconButton
                              size="small"
                              onClick={() => {
                                setNewUuid(auditoriasAccionesUUID[index]);
                                setOpenCloseAdj(!openCloseAdj);
                              }}
                              sx={{
                                color: "white",
                                backgroundColor: "rgba(255, 255, 255, 0.1)",
                                "&:hover": {
                                  backgroundColor: "rgba(255, 255, 255, 0.2)",
                                },
                              }}
                            >
                              <AttachFileIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        )}
                      </Box>
                    </Box>

                    {/* Contenido */}
                    <Box sx={{ p: 3, backgroundColor: "white" }}>
                      {/* Usuarios */}
                      <Box
                        sx={{
                          mb: 2,
                          display: "flex",
                          flexWrap: "wrap",
                          gap: 2,
                        }}
                      >
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <Typography
                            variant="caption"
                            sx={{
                              color: "#6b7280",
                              fontWeight: 600,
                              textTransform: "uppercase",
                              letterSpacing: "0.05em",
                            }}
                          >
                            Registra:
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              fontWeight: 600,
                              color: "#374151",
                            }}
                          >
                            {auditoriasAccionesUsuarioQueRegistro[index]}
                          </Typography>
                        </Box>

                        {auditoriasAccionesUsuarioQueFinalizo[index] && (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <Typography
                              variant="caption"
                              sx={{
                                color: "#6b7280",
                                fontWeight: 600,
                                textTransform: "uppercase",
                                letterSpacing: "0.05em",
                              }}
                            >
                              Finaliza:
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{
                                fontWeight: 600,
                                color: "#374151",
                              }}
                            >
                              {auditoriasAccionesUsuarioQueFinalizo[index]}
                            </Typography>
                          </Box>
                        )}
                      </Box>

                      {/* Descripción de la Acción */}
                      <Typography
                        variant="body1"
                        sx={{
                          color: "#1f2937",
                          lineHeight: 1.6,
                          fontSize: "0.95rem",
                        }}
                      >
                        {accion}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              );
            })}
          </Box>
        </Box>
      </Box>

      {openCloseAdj ? ( // ADJUNTAR
        <FileUploadAccion
          fileId={newUuid}
          openclose={true}
          mostrar={true}
          onClose={() => handleOpenCloseAdj(false)} // Proporciona una función de cierre
        />
      ) : null}

      {/* AGREGAR ACCION */}
      <Dialog
        open={openDialogAgregarAccion}
        onClose={handleCloseDialogCrearAccion}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "16px",
            boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
            overflow: "hidden",
          },
        }}
      >
        <Auditorias_agregar_accion
          row={row}
          openCrearAccion={openDialogAgregarAccion}
          date={date}
          // NOTIFICACION
          openSnack={openSnack}
          colormensaje={colormensaje}
          mensaje={mensaje}
          // ADJUNTOS
          newUuid={newUuid}
          // ACTUALIZAR
          actualizarAuditorias={actualizarAuditorias}
          // CERRAR
          handleCloseDialogCrearAccion={handleCloseDialogCrearAccion}
        />
      </Dialog>

      {/* EDITAR ITEM */}
      <Dialog
        open={openEditar}
        onClose={handleCloseEditar}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "16px",
            boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
            overflow: "hidden",
          },
        }}
      >
        <Box
          sx={{
            border: "2px solid #2B76A6",
            borderRadius: "16px",
          }}
        >
          <DialogTitle
            sx={{
              p: 0,
              mt: 0,
              mb: 3,
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-start",
            }}
          >
            <Typography
              variant="h6"
              color="white"
              sx={{
                background:
                  "linear-gradient(135deg, #2B76A6 0%, #094d77ff 100%)",
                borderBottomRightRadius: "12px",
                padding: "12px 24px",
                fontWeight: 600,
              }}
            >
              Editar Acción
            </Typography>
          </DialogTitle>
          <DialogContent sx={{ px: 3 }}>
            <Container maxWidth="xl">
              <form onSubmit={guardarEditar}>
                <Grid container spacing={2}>
                  <Grid item xs={12} mb={3} mt={1}>
                    <TextField
                      fullWidth
                      multiline
                      size="small"
                      value={accionSeleccionada}
                      onChange={(e) =>
                        setAccionSeleccionada(e.currentTarget.value)
                      }
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "12px",
                          "&:hover fieldset": {
                            borderColor: "#667eea",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#667eea",
                          },
                        },
                      }}
                    />
                  </Grid>
                </Grid>

                <Stack direction="row" sx={{ mt: 2 }}>
                  <Grid
                    container
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    {/* Botón a la izquierda */}
                    <Grid item>
                      <Button
                        variant="contained"
                        color="error"
                        onClick={handleCloseEditar}
                        sx={{
                          borderRadius: "12px",
                          textTransform: "none",
                          fontWeight: 600,
                        }}
                      >
                        Volver
                      </Button>
                    </Grid>

                    {/* Botones a la derecha */}
                    <Grid item>
                      <Stack direction="row" spacing={2}>
                        <Button
                          variant="contained"
                          color="success"
                          onClick={() => dialogFinalizar(idSeleccionado)}
                          disabled={hayCambios}
                          startIcon={<CheckCircleOutlineIcon />}
                          sx={{
                            borderRadius: "12px",
                            textTransform: "none",
                            fontWeight: 600,
                          }}
                        >
                          Finalizar Acción
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                          disabled={!hayCambios}
                          sx={{
                            borderRadius: "12px",
                            textTransform: "none",
                            fontWeight: 600,
                          }}
                        >
                          Guardar Cambios
                        </Button>
                      </Stack>
                    </Grid>
                  </Grid>
                </Stack>
              </form>
            </Container>
          </DialogContent>
        </Box>
      </Dialog>

      {/* DIALOG PARA CANCELAR LA ACCIÓN */}
      <Dialog
        open={openDialogEliminar}
        onClose={handleCloseDialogEliminar}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            border: "2px solid #2B76A6",
            boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
          },
        }}
      >
        <DialogContent sx={{ textAlign: "center", py: 4 }}>
          <DialogTitle textAlign={"center"}>
            {"¿Confirma que quiere cancelar esta acción?"}
          </DialogTitle>
          {props.auditorias[0].problema_sugerencia}
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", pb: 2, gap: 18 }}>
          <Button
            variant="contained"
            color="error"
            onClick={handleCloseDialogEliminar}
            sx={{
              borderRadius: "12px",
              textTransform: "none",
              fontWeight: 600,
            }}
          >
            Volver
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={guardarEliminar}
            sx={{
              borderRadius: "12px",
              textTransform: "none",
              fontWeight: 600,
            }}
          >
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>

      {/* DIALOG PARA BLOQUEAR/DESBLOQUEAR LA RELACION */}
      <Dialog
        open={openDialogFinalizar}
        onClose={handleCloseDialogFinalizar}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            border: "2px solid #22c55e",
          },
        }}
      >
        <DialogContent sx={{ textAlign: "center", py: 4 }}>
          <Typography
            variant="h6"
            sx={{ color: "#16a34a", fontWeight: 600, mb: 2 }}
          >
            ¿Confirma que quiere finalizar esta acción?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 3, gap: 2 }}>
          <Button
            variant="contained"
            color="error"
            onClick={handleCloseDialogFinalizar}
            sx={{
              borderRadius: "12px",
              textTransform: "none",
              fontWeight: 600,
            }}
          >
            Volver
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={guardarFinalizar}
            sx={{
              borderRadius: "12px",
              textTransform: "none",
              fontWeight: 600,
            }}
          >
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>

      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default Auditorias_acciones;
